import { useMutation } from '@tanstack/react-query';

import type { CreateEmployeeEmploymentContractArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: CreateEmployeeEmploymentContractArgs) => {
  return employeeService.createEmployeeEmploymentContract(data);
};

export const useEmployeeCreateEmploymentContractMutation = () => {
  return useMutation<unknown, unknown, CreateEmployeeEmploymentContractArgs>(mutationFn);
};
